import { useSearchParams } from 'react-router-dom';

export const useProjectListingsTabParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const listingsTabParam = searchParams.get('listingsTab');

  const deleteListingsTabParam = () => searchParams.delete('listingsTab');

  const setListingsTabParam = (stageId: string) =>
    setSearchParams(searchParams => {
      searchParams.set('listingsTab', stageId);
      return searchParams;
    });

  return { listingsTabParam, deleteListingsTabParam, setListingsTabParam };
};
